import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import * as C from '../screens';

const AppRouters = () => {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<C.Home />} />
        <Route path='/*' element={<Navigate to='/' />} />
      </Routes>
    </Router>
  );
};

export default AppRouters;
